
import drivingImage from '@disy/cadenza-icons/driving.svg';
import drivingHeavyImage from '@disy/cadenza-icons/driving-heavy.svg';
import cyclingImage from '@disy/cadenza-icons/cycling.svg';
import footImage from '@disy/cadenza-icons/foot.svg';
import wheelchairImage from '@disy/cadenza-icons/wheelchair.svg';
import beeImage from '@disy/cadenza-icons/experimental-bee.svg';
import albatrosImage from '@disy/cadenza-icons/experimental-albatros.svg';
import helicopterImage from '@disy/cadenza-icons/experimental-helicopter.svg';

import { icon } from 'cadenza/utils/icon/icon';
import { RoutingProfileGroup } from 'cadenza/map/routing/model/routing-profile-group';

const ICON_MAPPING = {
  driving: drivingImage,
  driving_heavy: drivingHeavyImage,
  cycling: cyclingImage,
  foot: footImage,
  wheelchair: wheelchairImage,
  airborne: helicopterImage
};

export function getIconForProfile (profile) {
  const label = RoutingProfileGroup.i18n(profile.group);
  if (profile?.name.toLowerCase() === 'airborne_bee') {
    return icon(beeImage, { label });
  } else if (profile?.name.toLowerCase() === 'airborne_gray_headed_albatros') {
    return icon(albatrosImage, { label });
  }
  const image = ICON_MAPPING[profile?.group.toLowerCase()];
  return image ? icon(image, { label }) : null;
}

export function getIconForProfileGroup (profileGroup) {
  if (profileGroup.toLowerCase() === 'airborne') {
    return icon(helicopterImage);
  }
  const image = ICON_MAPPING[profileGroup.toLowerCase()];
  return image ? icon(image) : null;
}
